import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import noop from 'lodash/noop';
import styled from '@emotion/styled';
import { Box, Flex, Radio } from '@qga/roo-ui/components';
import TextButton from 'components/TextButton';
import { PAYMENT_METHODS } from 'lib/enums/payment';
import FilterLabel from 'components/Filters/FilterLabel';
import FilterContainer from 'components/Filters/FilterContainer';
import { getQueryPayWith } from 'store/router/routerSelectors';
import { PAYWITH_TOGGLE_ENABLED } from 'config';

const PaymentTypeLabel = styled(FilterLabel)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PayWith = ({ onChange, onClearFilter, hideClear }) => {
  const payWith = useSelector(getQueryPayWith);

  if (!PAYWITH_TOGGLE_ENABLED) return null;

  return (
    <Fragment>
      <Flex justifyContent="space-between">
        {!hideClear && (
          <TextButton data-testid="clear-price-button" fontSize="sm" onClick={onClearFilter}>
            Clear
          </TextButton>
        )}
      </Flex>
      <Box mb={0}>
        <FilterContainer mb={hideClear ? 0 : 6} data-testid="price-filter">
          <Box as="form">
            <PaymentTypeLabel htmlFor="price-cash">
              <Box textAlign="left" fontSize="sm">
                <Radio
                  name="price"
                  id="price-cash"
                  value={PAYMENT_METHODS.CASH}
                  onChange={() => onChange({ payWith: PAYMENT_METHODS.CASH })}
                  checked={payWith === PAYMENT_METHODS.CASH}
                />
                Use Cash
              </Box>
            </PaymentTypeLabel>
          </Box>
          <Box as="form">
            <PaymentTypeLabel htmlFor="price-points">
              <Box textAlign="left" fontSize="sm">
                <Radio
                  name="price"
                  id="price-points"
                  value={PAYMENT_METHODS.POINTS}
                  onChange={() => onChange({ payWith: PAYMENT_METHODS.POINTS })}
                  checked={payWith === PAYMENT_METHODS.POINTS}
                />
                Use Qantas Points
              </Box>
            </PaymentTypeLabel>
          </Box>
        </FilterContainer>
      </Box>
    </Fragment>
  );
};

PayWith.propTypes = {
  payWith: PropTypes.string,
  onChange: PropTypes.func,
  onClearFilter: PropTypes.func,
  hideClear: PropTypes.bool,
};

PayWith.defaultProps = {
  payWith: PAYMENT_METHODS.CASH,
  onChange: noop,
  onClearFilter: () => {},
  hideClear: false,
};

export default PayWith;
